export const studentHelpUrl =
	'https://help.soomolearning.com/en/articles/9067771-how-do-i-use-study-stack';
export const instructorHelpUrl =
	'https://instructorhelp.soomolearning.com/en/articles/9067974-how-do-students-use-study-stack';
